import axios from "axios";
import API from "../helpers/api";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";
import { toast } from "react-toastify";


let user = JSON.parse(localStorage.getItem("currentUser"));
export const getApprovalCount = (user) => {
    let url = `${API.PendingApprovalCount}${user.email}`; //pendingtasks/count/approver={mailid}
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "PendingApprovalCountSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "PendingApprovalCountFailure",
                    error: "ERROR"
                })
            })
    }
};

export const getPendingShipCount = (user) => {
    let url = `${API.PendingShipCount}?mail=${user.email}`; //pendingtasks/count/approver={mailid}
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "PendingShipCountSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "PendingShipCountFailure",
                    error: "ERROR"
                })
            })
    }
};


export const getPendingApprovalsList = (user) => {
    let url = `${API.PendingApprovals}${user.email}`; //pendingtasks/task/approver={mailid}
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch(getApprovalCount(user));
                dispatch({
                    type: "PendingApprovalListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "PendingApprovalListFailure",
                    error: "ERROR"
                })
            })
    }
};

export const getPendingApprovalDetails = (id) => {
    let url = `${API.EquipmentList}?shipId=${id}&approver=${user.email}`; // pendingtasks/task/{shipId}
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch(getApprovalCount(user));
                dispatch({
                    type: "PendingApprovalDetailsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "PendingApprovalDetailsFailure",
                    error: "ERROR"
                })
            })
    }
};

export const getEquipmentDetails = (id) => {
    let url = `${API.GetEquipmentServiceTypeList}?ShipEquipmentId=${id}&mail=${user.email}`; // pendingtasks/task/{shipId}
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "PendingEquipmentDetailsSuccess",
                    data: response.data,
                })
                response.data && response.data.map((item, index) => {
                    if (item.attachmentGuid !== null && item.attachmentName !== null) {
                        let encodedAttachmentName = btoa(unescape(encodeURIComponent(item.attachmentName)));
                        /*  console.log("resultnew",encodedString,item.attachmentGuid) */
                        let url1 = `${API.DownloadAttachmentAPI}?filename=${encodedAttachmentName}&guidValue=${item.attachmentGuid}`;
                        /*   dispatch(showLoader()); */
                        axios.get(url1, { responseType: "blob" })
                            .then((result) => {
                                let blob = "";
                                blob = new Blob([result.data], { type: 'application/pdf' });
                                const fileURL = window.URL.createObjectURL(blob);
                                item["fileUrl"] = fileURL;
                                // dispatch({
                                //     type: "PendingEquipmentDetailsSuccess",
                                //     data: response.data,
                                // })
                            })
                    } else {
                        // dispatch({
                        //     type: "PendingEquipmentDetailsSuccess",
                        //     data: [],
                        // })
                    }
                    if (item.previousEquipmentServiceId !== 0) {
                        dispatch(getServiceImages(item.previousEquipmentServiceId, item.serviceType));
                    } else {
                        dispatch(getServiceImages(item.equipmentServiceId, item.serviceType));
                    }
                })
            })
            .catch((error) => {
                dispatch({
                    type: "PendingEquipmentDetailsFailure",
                    error: "ERROR"
                })
                dispatch({
                    type: "PendingEquipmentDetailsSuccess",
                    data: [],
                })
            })
    }
};

export const postApproval = (data, history,t) => {

    let url = `${API.PostApproval}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch({
                    type: "EquipmentApproved",
                    data: response.data,
                })
                dispatch({ type: "ShowSidePan", data: false });
                dispatch(getApprovalCount(user));
                history.push(`/Home/PendingApprovals`);
                toast.success(t('CommonText.CommonUpdate'), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
            .catch((error) => {
                dispatch({
                    type: "EquipmentRejected",
                    error: "ERROR"
                })
            })
    }
}

export const viewPDF = (attachmentName, attachmentGuid) => {
    let encodedAttachmentName = btoa(unescape(encodeURIComponent(attachmentName)));
    let url = `${API.DownloadAttachmentAPI}?filename=${encodedAttachmentName}&guidValue=${attachmentGuid}`;
    return dispatch => {
        axios
            .get(url, { responseType: "blob" })
            .then((response) => {
                let blob = "";
                blob = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = window.URL.createObjectURL(blob);
                dispatch({
                    type: "fileUrl",
                    data: fileURL,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "PendingEquipmentDetailsFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getServiceImages = (id, serviceType) => {
    let url = `${API.ServiceImages}${id}`; // pendingtasks/task/{shipId}
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch(showLoader());
                if (serviceType === "1 yearly") {
                    dispatch({
                        type: "serviceImages-1 yearly",
                        data: response.data,
                    })
                } if (serviceType === "2 yearly") {
                    dispatch({
                        type: "serviceImages-2 yearly",
                        data: response.data,
                    })
                } if (serviceType === "3 yearly") {
                    dispatch({
                        type: "serviceImages-3 yearly",
                        data: response.data,
                    })
                } if (serviceType === "5 yearly") {
                    dispatch({
                        type: "serviceImages-5 yearly",
                        data: response.data,
                    })
                } if (serviceType === "10 yearly") {
                    dispatch({
                        type: "serviceImages-10 yearly",
                        data: response.data,
                    })
                }
                dispatch(hideLoader());
            })
            .catch((error) => {
                dispatch({
                    type: "PendingEquipmentDetailsFailure",
                    error: "ERROR"
                })
            })
    }
};


